import React from "react";
import { Box, Typography } from "@mui/material";

const brandBlue = "#2563EB";
const darkText = "#0A2540";

const brandMarkUrl = `${process.env.PUBLIC_URL}/1000266666_imgupscaler.ai_V1(Fast)_4K.png.jpg`;

const sizes = {
  sm: { mark: 30, name: "16px", gap: 0.8 },
  md: { mark: 38, name: "20px", gap: 1 },
  lg: { mark: 48, name: "26px", gap: 1.2 },
  xl: { mark: 56, name: "32px", gap: 1.5 },
};

export default function FiLogo({ size = "md", light = false }) {
  const s = sizes[size] || sizes.md;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: s.gap, flexShrink: 0 }}>
      <Box
        component="img"
        src={brandMarkUrl}
        alt="FI Pay Bills"
        sx={{
          width: s.mark,
          height: s.mark,
          objectFit: "cover",
          borderRadius: "10px",
          flexShrink: 0,
          display: "block",
          boxShadow: "0 2px 8px rgba(37,99,235,0.2)",
        }}
      />

      <Typography sx={{
        fontWeight: 700, fontSize: s.name,
        lineHeight: 1.1, letterSpacing: "-0.5px",
        fontFamily: "'Inter', sans-serif",
        whiteSpace: "nowrap",
      }}>
        <Box component="span" sx={{ color: brandBlue }}>FI</Box>
        <Box component="span" sx={{ color: light ? "#FFFFFF" : darkText }}> Pay Bills</Box>
      </Typography>
    </Box>
  );
}
